module.exports = __webpack_public_path__ + "img/user-persona-desktop.58bc2bd4.png";